import styled from 'styled-components';

interface ThProps {
  $sortable?: boolean;
}

export const Th = styled.th<ThProps>`
  color: #696969;
  background-color: #f5f5f5;
  text-align: start;
  border: 0;
  font-size: 0.7rem;
  font-weight: 400;
  padding: 0 1.2rem;
  height: 2.2rem;
  cursor: ${({ $sortable }) => ($sortable ? 'pointer' : 'default')};
  transition: background 0.2s;
  &:hover {
    background: ${({ $sortable }) => ($sortable ? '#f1f3f5' : '#f5f5f5')};
  }
`;

export const ThContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ConfigMenuWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const ConfigMenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bdbdbd;
  transition: color 0.2s;
  &:hover {
    color: #757575;
  }
`;

export const ColumnMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 8px 0;
  min-width: 180px;
  z-index: 100;
`;

export const ColumnMenuList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 240px;
  overflow-y: auto;
`;

export const ColumnMenuItem = styled.label`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 0.75rem;
  color: #444;
  gap: 8px;
  transition: background 0.15s;
  &:hover {
    background: #f5f5f5;
  }
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

export const StyledCheckbox = styled.span<{ $checked: boolean }>`
  width: 14px;
  height: 14px;
  min-width: 14px;
  border-radius: 3px;
  border: 1.5px solid ${({ $checked }) => ($checked ? '#4caf50' : '#bdbdbd')};
  background: ${({ $checked }) => ($checked ? '#4caf50' : '#fff')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  &::after {
    content: '';
    display: ${({ $checked }) => ($checked ? 'block' : 'none')};
    width: 4px;
    height: 7px;
    border: 2px solid #fff;
    border-top: none;
    border-left: none;
    transform: rotate(45deg) translate(-1px, -1px);
  }
`;
